var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"mx-5"},[_c('h1',[_vm._v("Licencias")]),_c('LmLicenses',{attrs:{"isAdmin":"","user":_vm.$route.params.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }